export const PCMaxWidth = "1200px";

export const heightWithoutAppBar = "93vh";

export const PCPaddingX = "12px";
